import OwnerModel                  from 'Models/intervention/OwnerModel';
import SourceModel                 from 'Models/invoice/SourceModel';
import ContractIterationModel      from 'Models/sales/ContractIterationModel';
import ContractModel               from 'Models/sales/ContractModel';
import QuotationModel              from 'Models/sales/QuotationModel';
import doc                         from 'decorators/doc';
import model                       from 'decorators/model';
import { Timestampable }           from 'helpers/traits';
import InterventionPrivateApiModel from 'modelx/models/abstracts/InterventionPrivateApiModel';

const customDoc = doc;

@model.staticLabel('TaskHolder')
@model.urnResource('task_holder')
@doc.path('/task_holders/{?id}')
export default class TaskHolderModel extends Timestampable(InterventionPrivateApiModel) {
	public _filters: ModelFiltersExtended<{
		'holderUrn': Urn;
		'tags[serviceUrn][tagReference]': id;
		'tasks': id;
		'tasks.tags[serviceUrn][tagReference]': id;
		'tasks.taskOperations': id;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
	}> = {};

	@doc.string declare label: string;
	@doc.model(OwnerModel) declare owner: OwnerModel;

	@customDoc.modelUrn(SourceModel) declare holder: QuotationModel | ContractIterationModel | ContractModel | SourceModel;
}